<template>
  <div class="transList">
<v-card>
  <v-card-title>
    <img src="../../../static/images/icon8icons/icons8-todo-list-50.png" /><br />
    <h1>Activity</h1>
    <v-spacer/>
    <v-flex xs3>
      <v-select
            :items="selectItems"
            v-model="transactionDays"
            @change="setTransactionDays"
            label="Show:"
      ></v-select>
    </v-flex>
    <v-btn @click="refresh" flat color="accent">
       Refresh
    </v-btn>

  </v-card-title>

  <v-data-table
    :headers="headers"
    :items="transactions"
    :loading="transactionsLoading"
    mustSort
    class="elevation-1"
    no-data-text="No data loaded. Try pressing refresh"
    :pagination.sync="pagination"
  >
    <template
      slot="items"
      slot-scope="props"
    >
      <tr>
        <td class="body-2 text-xs-left">{{ formatDate(props.item.created) }}</td>
        <td class="body-2 text-xs-left" v-html="props.item.text"></td>
      </tr>
    </template>

  </v-data-table>
</v-card>

      <hr />
</div>

</template>

<script>
import {mapState} from 'vuex'
// import utils from '../../utils.ts'

export default {
  name: 'RecentActivity',
  components: {
  },
  data () {
    return {
      loading: false,
      transactionDays: 7,
      headers: [
        {text: 'Date', value: 'created', align: 'left'},
        {text: 'Activity', value: 'transactions.text', align: 'left'}
      ],
      selectItems: [
        {text: 'Last 7 Days', value: 7},
        {text: 'Last 30 Days', value: 30}
      ],
      pagination: {
        sortby: 'created',
        descending: true
      }

    }
  },
  computed: {
    ...mapState({
      transactions: state => state.admin.transactions,
      transactionsLoading: state => state.admin.transactionsLoading,
      transactionSearchDays: state => state.admin.transactionSearchDays
    })
  },
  mounted: function () {
    // console.log('ITEMS: ' + this.items)
    // console.log('computedOrders: ' + JSON.stringify(this.computedOrders))
    this.$store.dispatch('admin/loadTransactions')
  },
  methods: {
    refresh: function () {
      this.$store.dispatch('admin/loadTransactions')
    },
    formatDate: function (created) {
      const d = new Date(created.seconds * 1000) // Convert from seconds to Date
      return d.toLocaleString()
    },
    setTransactionDays: function () {
      this.$store.commit('admin/setTransactionSearchDays', this.transactionDays)
      this.refresh()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.transList {
  width: 100%;
}

</style>
